import ReactDOM from 'react-dom';
import 'typeface-roboto';
import { App } from './App';
import './index.css';
import './megadraft.css';

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
